import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Box,
  Divider,
  MenuItem,
  MenuList,
  Popover,
  Typography,
  Grid2 as Grid,
  Stack,
  useMediaQuery,
} from "@mui/material";
import NotaryNotifications from "../popover/notifications/NotaryNotifications";
import { useNavigate } from "react-router-dom";
import { navigateToRealRequestsTab } from "../../store/actions/notaryActions";

export const NotaryNotification = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [notificationLoading, setNotificationLoading] = useState("");

  const { anchorEl, onClose, open } = props;

  const isMd = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const onNotificationClick = (notification) => {
    if (notification === "realtime") {
      dispatch(navigateToRealRequestsTab());
      navigate("/notary/history");
    }
  };

  return (
    <>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: "left", // Adjusted to "right" instead of "left"
          vertical: "bottom",
        }}
        onClose={onClose}
        open={open}
      >
        <Box
          sx={
            isMd
              ? {
                  display: "flex",
                  width: "100%",
                  py: 1.5,
                  px: 2,
                }
              : { display: "flex", width: "25rem", py: 1.5, px: 2 }
          }
        >
          <Box sx={{ flex: 2 }}>
            <Stack>
              <Typography mt={1} variant="h6">
                Notifications
              </Typography>
            </Stack>
          </Box>
        </Box>
        <Divider />

        <NotaryNotifications
          onNotificationClick={onNotificationClick}
          notificationLoading={notificationLoading}
        />
      </Popover>
    </>
  );
};
